// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"4f66da42","241":"a169fd86","453":"2036ebc9","526":"5b51fc3d","683":"e7e7533e"}[chunkId] + ".chunk.js";
};